// @flow

import * as React from 'react';

import { useTranslator } from '@gandi/translate';
import { ToggleGroup, TogglePill, Text } from '@gandi/ui';

export const CUSTOMER = 'customer';
export const ORGANIZATION = 'organization';
export const RESELLER = 'reseller';

const ownerTypes: {
  customer: string,
  organization: string,
  reseller: string,
} = {
  [CUSTOMER]: CUSTOMER,
  [ORGANIZATION]: ORGANIZATION,
  [RESELLER]: RESELLER,
};

export type OwnerType = $Keys<typeof ownerTypes>;

type Props = {
  type: OwnerType,
  onChange: (type: OwnerType) => mixed,
};

function ResellerOwnerType({ type, onChange }: Props): React.Node {
  const { __ } = useTranslator();

  const handleChange = (evt: SyntheticInputEvent<>) => {
    // $FlowFixMe[invalid-computed-prop]
    const value = ownerTypes[evt.target.value];
    if (value) onChange(value);
  };

  return (
    <>
      <ToggleGroup
        value={type}
        name="reseller-owner-type"
        onChange={handleChange}
      >
        <TogglePill value={CUSTOMER}>{__('For a customer')}</TogglePill>
        <TogglePill value={RESELLER}>
          {__('For my reseller organization')}
        </TogglePill>
        <TogglePill value={ORGANIZATION}>{__('For someone else')}</TogglePill>
      </ToggleGroup>
      {type === CUSTOMER && (
        <p>
          {__(
            'I am buying products that will belong to one of my existing (or future) customers, but that my reseller organization will manage.',
          )}{' '}
          <Text weight="semibold">
            {__(
              'Please note that for web hosting products, the ownership remains to the reseller organization.',
            )}
          </Text>
        </p>
      )}
      {type === RESELLER && (
        <p>
          {__(
            'I am buying products that my reseller organization will own and manage.',
          )}
        </p>
      )}
      {type === ORGANIZATION && (
        <p>
          {__(
            'I am buying products for a third party, and they will not be managed by my reseller organization.',
          )}
        </p>
      )}
    </>
  );
}

export default ResellerOwnerType;
